import { createFileRoute } from '@tanstack/react-router';

import { InvestorBootPage } from '@/features/investor-entry/public';

export const Route = createFileRoute('/')({
  component: InvestorBootPage,
});
